/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowDownSmall: {
  name: 'arrow_down_small';
  data: string;
} = {
  name: 'arrow_down_small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M15.968 13.844a.75.75 0 0 0-1.06-1.06L12.25 15.44V6.75a.75.75 0 0 0-1.5 0v8.69l-2.657-2.657a.75.75 0 1 0-1.06 1.06l3.937 3.937a.75.75 0 0 0 1.06 0l3.938-3.936Z" fill="currentColor"/></svg>`
};
